import type { LayerGroup } from "@/types/explore"
import { LEGENDS } from "./legends"

export const LAYER_GROUPS: LayerGroup[] = [
  {
    label: "Portefeuille",
    color: "info",
    layers: [
      { id: "prospects-dossiers", name: "Prospects / Dossiers" },
      { id: "patrimoine", name: "Patrimoine" },
    ],
  },
  {
    label: "Urbanisme",
    color: "primary",
    layers: [
      {
        id: "plu",
        name: "PLU",
        legend: LEGENDS.plu,
        filters: [
          {
            id: "plu-zones",
            label: "Zones",
            type: "multi",
            options: ["U", "AUc", "AUs", "N", "A"],
          },
          {
            id: "plu-subzones",
            label: "Sous zones PLU",
            type: "multi",
            options: [],
            dynamic: true,
          },
          { id: "plu-opacity", label: "Opacite", type: "slider" },
        ],
      },
      {
        id: "abf",
        name: "ABF",
        filters: [{ id: "abf-opacity", label: "Opacite", type: "slider" }],
      },
      {
        id: "qpv",
        name: "QPV",
        legend: LEGENDS.qpv,
        filters: [{ id: "qpv-opacity", label: "Opacite", type: "slider" }],
      },
    ],
    subgroups: [
      {
        label: "Prescriptions",
        layers: [
          {
            id: "presc-ebc",
            name: "Espaces boises classes a proteger, conserver, creer",
            legend: LEGENDS["presc-ebc"],
          },
          { id: "presc-er", name: "Emplacement reserve", legend: LEGENDS["presc-er"] },
          { id: "presc-pdm", name: "Secteur de plan de masse", legend: LEGENDS["presc-pdm"] },
          { id: "presc-ric", name: "Regles d'implantation des constructions", legend: LEGENDS["presc-ric"] },
          { id: "presc-pms", name: "Programme de mixite sociale", legend: LEGENDS["presc-pms"] },
          { id: "presc-oap", name: "OAP", legend: LEGENDS["presc-oap"] },
          { id: "presc-emprise", name: "Emprise au sol", legend: LEGENDS["presc-emprise"] },
          { id: "presc-hauteur", name: "Hauteur", legend: LEGENDS["presc-hauteur"] },
          { id: "presc-volumetrie", name: "Volumetrie", legend: LEGENDS["presc-volumetrie"] },
          { id: "presc-stationnement", name: "Stationnement", legend: LEGENDS["presc-stationnement"] },
        ],
      },
      {
        label: "Infos",
        layers: [
          { id: "info-zac", name: "Zone d'amenagement concerte", legend: LEGENDS["info-zac"] },
          {
            id: "info-zpens",
            name: "Zone de preemption dans un espace naturel et sensible",
            legend: LEGENDS["info-zpens"],
          },
          { id: "info-dpu", name: "Perimetre de droit de preemption urbain", legend: LEGENDS["info-dpu"] },
          {
            id: "info-div-fonc",
            name: "Divisions foncieres soumises a declaration prealable",
            legend: LEGENDS["info-div-fonc"],
          },
          { id: "info-sursis", name: "Perimetre de sursis a statuer", legend: LEGENDS["info-sursis"] },
          { id: "info-pae", name: "Secteur de programme d'amenagement d'ensemble", legend: LEGENDS["info-pae"] },
          { id: "info-bruit", name: "Secteur affecte par le bruit", legend: LEGENDS["info-bruit"] },
          { id: "info-archeo", name: "Site archeologique", legend: LEGENDS["info-archeo"] },
          { id: "info-ppr", name: "Projet de plan de prevention des risques", legend: LEGENDS["info-ppr"] },
          { id: "info-peb", name: "Plan d'exposition au bruit des aerodromes", legend: LEGENDS["info-peb"] },
          { id: "info-taxe", name: "Secteur de taxe d'amenagement", legend: LEGENDS["info-taxe"] },
          { id: "info-sis", name: "Secteurs d'information sur les sols", legend: LEGENDS["info-sis"] },
          { id: "info-chaleur", name: "Reseau de chaleur", legend: LEGENDS["info-chaleur"] },
          { id: "info-mh", name: "Monuments historiques" },
          { id: "info-gares", name: "Perimetre des gares (500 m)", legend: LEGENDS["info-gares"] },
        ],
      },
    ],
  },
  {
    label: "Risques",
    color: "error",
    layers: [
      {
        id: "argile",
        name: "Argile",
        legend: LEGENDS.argile,
        filters: [{ id: "argile-opacity", label: "Opacite", type: "slider" }],
      },
      {
        id: "seisme",
        name: "Sismicite",
        legend: LEGENDS.seisme,
        filters: [{ id: "seisme-opacity", label: "Opacite", type: "slider" }],
      },
      {
        id: "radon",
        name: "Radon",
        legend: LEGENDS.radon,
        filters: [{ id: "radon-opacity", label: "Opacite", type: "slider" }],
      },
      {
        id: "inondation",
        name: "Inondation",
        legend: LEGENDS.inondation,
        filters: [{ id: "inond-opacity", label: "Opacite", type: "slider" }],
      },
      {
        id: "ppri",
        name: "PPRI",
        legend: LEGENDS.ppri,
        filters: [{ id: "ppri-opacity", label: "Opacite", type: "slider" }],
      },
      {
        id: "pollution",
        name: "Pollution",
        legend: LEGENDS.pollution,
        filters: [{ id: "poll-opacity", label: "Opacite", type: "slider" }],
      },
    ],
  },
  {
    label: "Fonds de carte",
    color: "warning",
    layers: [
      { id: "terrain-3d", name: "Relief 3D" },
      { id: "denivele", name: "Denivele" },
      {
        id: "isochrone-walk",
        name: "Isochrone pieton",
        legend: LEGENDS["isochrone-walk"],
        filters: [{ id: "iso-w-opacity", label: "Opacite", type: "slider" }],
      },
      {
        id: "isochrone-drive",
        name: "Isochrone voiture",
        legend: LEGENDS["isochrone-drive"],
        filters: [{ id: "iso-d-opacity", label: "Opacite", type: "slider" }],
      },
      {
        id: "isochrone-bike",
        name: "Isochrone velo",
        legend: LEGENDS["isochrone-bike"],
        filters: [{ id: "iso-b-opacity", label: "Opacite", type: "slider" }],
      },
    ],
  },
  {
    label: "Donnees",
    color: "success",
    layers: [
      {
        id: "pc",
        name: "Permis de construire",
        filters: [
          {
            id: "pc-status",
            label: "Statut",
            type: "multi",
            options: ["2", "4", "5", "6"],
            labels: { "2": "Autorise", "4": "Annule", "5": "Commence", "6": "Termine" },
            colors: {
              "2": "rgb(34, 197, 94)",
              "4": "rgb(239, 68, 68)",
              "5": "rgb(234, 179, 8)",
              "6": "rgb(59, 130, 246)",
            },
          },
          {
            id: "pc-dest",
            label: "Destination",
            type: "select",
            options: ["Toutes", "Logement", "Commerce", "Bureau"],
          },
          { id: "pc-year", label: "Annee min.", type: "number" },
          { id: "pc-denomination", label: "Demandeur", type: "text" },
          { id: "pc-lots", label: "Nb lots min.", type: "number" },
        ],
      },
      {
        id: "dpe",
        name: "DPE",
        filters: [
          {
            id: "dpe-class",
            label: "Classes",
            type: "multi",
            options: ["A", "B", "C", "D", "E", "F", "G"],
            colors: {
              A: "rgb(26, 152, 80)",
              B: "rgb(145, 207, 96)",
              C: "rgb(217, 239, 139)",
              D: "rgb(255, 255, 191)",
              E: "rgb(254, 224, 139)",
              F: "rgb(252, 141, 89)",
              G: "rgb(215, 48, 39)",
            },
          },
        ],
      },
    ],
  },
]

export const ALL_LAYERS_FLAT = LAYER_GROUPS.flatMap((g) => [
  ...g.layers,
  ...(g.subgroups || []).flatMap((s) => s.layers),
])

export const PRESC_INFO_IDS = new Set([
  "presc-ebc",
  "presc-er",
  "presc-pdm",
  "presc-ric",
  "presc-pms",
  "presc-oap",
  "presc-emprise",
  "presc-hauteur",
  "presc-volumetrie",
  "presc-stationnement",
  "info-zac",
  "info-zpens",
  "info-dpu",
  "info-div-fonc",
  "info-sursis",
  "info-pae",
  "info-bruit",
  "info-archeo",
  "info-ppr",
  "info-peb",
  "info-taxe",
  "info-sis",
  "info-chaleur",
  "info-gares",
])
